import {
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import BaseItemModel from './base-item';
import type CommentModel from './comment';
import type InitiativeModel from './initiative';
import type PersonModel from './person';
import type TeamModel from './team';

export default class WfaModel extends BaseItemModel {
  declare [Type]: 'wfa';
  @belongsTo('initiative', { inverse: 'wfas', async: true })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
  @belongsTo('team', { inverse: 'wfas', async: true })
  declare team: AsyncBelongsTo<TeamModel>;
  @belongsTo('person', { inverse: 'wfas', async: true })
  declare author: AsyncBelongsTo<PersonModel>;
  @hasMany('comment', {
    async: true,
    inverse: 'wfa',
  })
  declare comments: AsyncHasMany<CommentModel>;
  @hasMany('person', {
    async: true,
    inverse: null,
  })
  declare assignees: AsyncHasMany<PersonModel>;
}
